/**
 * ChannelReachability (source=contacts, type=channel_reachability).
 * Backend: { chart: 'horizontal_bar', total, series: [{name, value, pct}] }
 */
import React from 'react';
import { Box, Text, Progress, Stat, StatLabel, StatNumber, VStack, HStack } from '@chakra-ui/react';

export default function ChannelReachability({ data }) {
  const total = data?.total || 0;
  const series = data?.series || [];
  return (
    <VStack align="stretch" spacing={3}>
      <Stat>
        <StatLabel fontSize="xs" color="gray.500">Total contacts</StatLabel>
        <StatNumber fontSize="lg">{Number(total).toLocaleString()}</StatNumber>
      </Stat>
      {series.map((s) => (
        <Box key={s.name}>
          <HStack justify="space-between" mb={1}>
            <Text fontSize="xs" fontWeight="medium">{s.name}</Text>
            <Text fontSize="xs" color="gray.600">{Number(s.value).toLocaleString()} ({s.pct}%)</Text>
          </HStack>
          <Progress value={s.pct} size="sm" colorScheme={s.pct >= 50 ? 'green' : s.pct >= 10 ? 'orange' : 'red'} borderRadius="md" />
        </Box>
      ))}
    </VStack>
  );
}
